__turbopack_context__.v({
  "ctaLegal": "maiacard-module-scss-module__DisIoW__ctaLegal",
  "emptyRow": "maiacard-module-scss-module__DisIoW__emptyRow",
  "externalCta": "maiacard-module-scss-module__DisIoW__externalCta",
  "fixedCardHeight": "maiacard-module-scss-module__DisIoW__fixedCardHeight",
  "flagOffset": "maiacard-module-scss-module__DisIoW__flagOffset",
  "headerGrid": "maiacard-module-scss-module__DisIoW__headerGrid",
  "maiaCardWrapper": "maiacard-module-scss-module__DisIoW__maiaCardWrapper",
  "multiCardGrid": "maiacard-module-scss-module__DisIoW__multiCardGrid",
  "ymmBanner": "maiacard-module-scss-module__DisIoW__ymmBanner",
});
